import React from 'react'

function Contact() {
  return (
    <div className="d-flex flex-column justify-content-center mx-5" >
      <h2 className="text-center mb-5 " style={{ color: "#513aa3ff",marginBottom:"15px" }}>Wolcome to Download Page </h2>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem similique fugiat alias, officiis assumenda hic distinctio beatae tempora animi quaerat vitae impedit culpa, eveniet enim.</p>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem similique fugiat alias, officiis assumenda hic distinctio beatae tempora animi quaerat vitae impedit culpa, eveniet enim.</p>
        <input type="submit" value="Download" className='btn btn-primary mx-5 mt-3' style={{fontWeight:"bold",color:"#000",}}/>
    </div>
  )
}

export default Contact ;